import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiPaper = {
  styleOverrides: { root: { backgroundImage: 'none' } },
} satisfies Components<Theme>['MuiPaper'];
